import React, { useState, useEffect } from 'react';
import './Loader.css';

function Loader({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1800);
    const doneTimer = setTimeout(onDone, 2300);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div className={`loader${fading ? ' loader--fade' : ''}`}>
      <div className="loader-content">
        <img
          src={require('../images/MKMonogramWhite.svg').default}
          alt="M&K"
          className="loader-logo"
        />
        <div className="loader-line" />
        <div className="loader-name">Mac &amp; Kyla</div>
        <div className="loader-tagline">April 25, 2026</div>
      </div>
    </div>
  );
}

export default Loader;
